import ProductPackComponent from '../components/products-pack/products'

const Products = () => <ProductPackComponent />

export default Products;